import { YoyoServiceApiFactory, type ModelYoyoResponse } from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const getValidCampaignSettings = async (id: string): Promise<ModelYoyoResponse> => {
  const client = createLayupClient();
  const response = await YoyoServiceApiFactory(undefined, undefined, client).yoyoServiceGetCampaignsById({ id: id });
  return response.data;
};
